import { handleException } from 'actions/exceptions';
import { ApiService } from 'services';

export const SEARCH_BATCH_FILES_REQUEST = 'SEARCH_BATCH_FILES_REQUEST';
export const SEARCH_BATCH_FILES_SUCCESS = 'SEARCH_BATCH_FILES_SUCCESS';
export const SEARCH_BATCH_FILES_FAILURE = 'SEARCH_BATCH_FILES_FAILURE';

function requestSearchBatchFiles() {
  return {
    type: SEARCH_BATCH_FILES_REQUEST,
    isGettingBatchFiles: true
  };
}

function receiveSearchBatchFiles(batchFiles, batchFilesCount) {
  return {
    type: SEARCH_BATCH_FILES_SUCCESS,
    isGettingBatchFiles: false,
    batchFiles,
    batchFilesCount
  };
}

function rejectSearchBatchFiles() {
  return {
    type: SEARCH_BATCH_FILES_FAILURE,
    isGettingBatchFiles: false
  };
}

export function searchBatchFiles(batchId, pageNumber, pageSize, sortBy, sortDirection, filters, searchQuery) {
  return (dispatch) => {
    dispatch(requestSearchBatchFiles());
    const promise = () => ApiService
      .searchBatchFiles(batchId, pageNumber, pageSize, sortBy, sortDirection, filters, searchQuery)
      .then((response) => {
        dispatch(receiveSearchBatchFiles(response.data.batchFiles, response.data.totalCount));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, rejectSearchBatchFiles, true));
        }
      });
    return promise();
  };
}
